import React, { useRef } from "react";
import { Box, Tooltip } from "@mui/material";
import { styles } from "Components/Appointments/styles";

const TruncateText = ({ text }) => {
  const textRef = useRef(null);

  return (
    <Tooltip
      title={text}
      placement="bottom-start"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: { offset: [-5, -10] },
            },
          ],
        },
      }}
    >
      <Box sx={styles.truncatedText} ref={textRef} aria-label={text}>
        {text}
      </Box>
    </Tooltip>
  );
};

export default TruncateText;
